<div>
    <app-domain-form></app-domain-form>
</div>
<div>
    <app-domain-list></app-domain-list>
</div>
